const homeforTranslations = {
  en: {
    heroTitle: "AKAAL KIDS",
    heroSubtitle: "Online Gurmat Education Institute",
    heroTrust:
      "Founded under Shan-E-Khalsa (Since 2006) Inspired by Fatehgarh Sahib",
    videoHeading: "Our Vision for the Next Generation",
    videoSubtext:
      "A message for parents seeking Gurmat-based education for their children.",
    videoPlay: "Play Video",
    ctaEnroll: "Enroll Now",
    ctaWatch: "Watch Video",
    aboutShortHeading: "About Akaal Kids",
    aboutShortText:
      "Akaal Kids is a dedicated online Gurmat education institute created to guide children towards a life rooted in Sikhi, values, and spiritual discipline. Founded under the vision of Shan-E-Khalsa (est. 2006), Akaal Kids builds upon nearly two decades of Gurmat service including Sikh camps, seminars, and globally recognized Sikh films. Our mission is simple yet powerful — to help children understand Gurbani, live with values, and lead with faith in today’s world.",
    aboutShortBtn: "Learn More About Us",
    whyHeading: "Why Parents Choose Akaal Kids",
    whyPoints: [
      "Gurmat-based learning, not ritual-based",
      "Focus on Bibek Budhi & character building",
      "Small batches with personal attention",
      "Child-friendly, fear-free environment",
      "Structured curriculum with clear progress",
      "Global classes across time zones",
    ],
    learningModelHeading: "OUR LEARNING MODEL",
    learningModelSub: "How Children Learn at Akaal Kids",
    learningCards: [
      {
        icon: "🧠",
        title: "Gurbani Kanth",
        desc: "Memorization that strengthens focus, confidence, and inner clarity.",
      },
      {
        icon: "✍️",
        title: "Sunehre Panne",
        desc: "Handwriting Gurbani to deepen understanding and discipline.",
      },
      {
        icon: "📚",
        title: "Khed Khed Vich Sikhiya",
        desc: "Life values taught through stories, discussion, and reflection.",
      },
      {
        icon: "🌱",
        title: "Life Application",
        desc: "Connecting Gurbani with daily decisions and real-life situations.",
      },
    ],
    coursesHeading: "Courses & Batches",
    coursesText:
      "Our courses are level-based, not age-based, ensuring every learner feels confident and supported.",
    levels: ["Foundation", "Understanding", "Depth", "Mastery"],
    classFormat: [
      "45-minute live interactive classes",
      "Evening hours (4:30 PM – 8:30 PM local time)",
      "Global participation",
    ],
    batchesBtn: "View Batches & Levels",
    admissionHeading: "Admissions Open – Limited Seats",
    admissionText:
      "Enrollment at Akaal Kids is simple and flexible. Parents can enroll directly online or connect with us on WhatsApp for guidance.",
    admissionBtn: "Enroll Now",
    whatsappBtn: "WhatsApp Us",
  },
  pa: {
    heroTitle: "ਅਕਾਲ ਕਿਡਜ਼",
    heroSubtitle: "ਆਨਲਾਈਨ ਗੁਰਮਤਿ ਸਿੱਖਿਆ ਸੰਸਥਾ",
    heroTrust: "ਸ਼ਾਨ-ਏ-ਖ਼ਾਲਸਾ (2006 ਤੋਂ) ਦੇ ਅਧੀਨ, ਫਤਹਿਗੜ੍ਹ ਸਾਹਿਬ ਤੋਂ ਪ੍ਰੇਰਿਤ",
    videoHeading: "ਅਗਲੀ ਪੀੜ੍ਹੀ ਲਈ ਸਾਡਾ ਦ੍ਰਿਸ਼ਟੀਕੋਣ",
    videoSubtext:
      "ਮਾਪਿਆਂ ਲਈ ਸੁਨੇਹਾ, ਜੋ ਆਪਣੇ ਬੱਚਿਆਂ ਲਈ ਗੁਰਮਤਿ ਅਧਾਰਿਤ ਸਿੱਖਿਆ ਚਾਹੁੰਦੇ ਹਨ।",
    videoPlay: "ਵੀਡੀਓ ਚਲਾਓ",
    ctaEnroll: "ਦਾਖਲਾ ਲਵੋ",
    ctaWatch: "ਵੀਡੀਓ ਵੇਖੋ",
    aboutShortHeading: "ਅਕਾਲ ਕਿਡਜ਼ ਬਾਰੇ",
    aboutShortText:
      "ਅਕਾਲ ਕਿਡਜ਼ ਇੱਕ ਵਿਸ਼ੇਸ਼ ਆਨਲਾਈਨ ਗੁਰਮਤਿ ਸਿੱਖਿਆ ਸੰਸਥਾ ਹੈ, ਜਿਸਦਾ ਮਕਸਦ ਬੱਚਿਆਂ ਨੂੰ" +
      "ਸਿੱਖੀ ਨਾਲ ਜੋੜਨਾ, ਆਤਮਿਕ ਮਜ਼ਬੂਤੀ ਦੇਣਾ ਅਤੇ ਸਿਧਾਂਤਾਂ ਨਾਲ ਨਿਖਾਰਨਾ ਹੈ। " +
      "ਇਹ ਉਪਰਾਲਾ ਸ਼ਾਨ-ਏ-ਖ਼ਾਲਸਾ (ਸਥਾਪਨਾ 2006) ਦੀ ਸੋਚ ਤੋਂ ਪ੍ਰੇਰਿਤ ਹੈ, ਜੋ ਲਗਭਗ ਦੋ ਦਹਾਕਿਆਂ ਤੋਂ" +
      "ਗੁਰਮਤਿ ਕੈਂਪਾਂ, ਸੈਮੀਨਾਰਾਂ ਅਤੇ ਸਿੱਖੀ ਪ੍ਰੇਰਕ ਫਿਲਮਾਂ ਰਾਹੀਂ ਸੇਵਾ ਕਰ ਰਹੀ ਹੈ। " +
      "ਸਾਡਾ ਮਕਸਦ ਹੈ — ਬੱਚਿਆਂ ਨੂੰ ਗੁਰਬਾਣੀ ਸਮਝਾਉਣਾ, ਜੀਵਨ ਜਾਚ ਸਿਖਾਉਣਾ ਅਤੇ ਵਿਸ਼ਵਾਸ ਨਾਲ ਅੱਗੇ ਵਧਣ ਯੋਗ ਬਣਾਉਣਾ।",
    aboutShortBtn: "ਹੋਰ ਜਾਣੋ",
    whyHeading: "ਮਾਪੇ ਅਕਾਲ ਕਿਡਜ਼ ਕਿਉਂ ਚੁਣਦੇ ਹਨ",
    whyPoints: [
      "ਰਸਮਾਂ ਨਹੀਂ, ਗੁਰਮਤਿ ਅਧਾਰਿਤ ਸਿੱਖਿਆ",
      "ਬਿਬੇਕ ਬੁੱਧੀ ਅਤੇ ਕਿਰਦਾਰ ਨਿਰਮਾਣ",
      "ਛੋਟੇ ਗਰੁੱਪ – ਵਿਅਕਤੀਗਤ ਧਿਆਨ",
      "ਡਰ ਰਹਿਤ, ਪਿਆਰ ਭਰਿਆ ਮਾਹੌਲ",
      "ਸੁਧਾਰਤ ਪਾਠਕ੍ਰਮ, ਸਾਫ਼ ਤਰੱਕੀ",
      "ਗਲੋਬਲ ਕਲਾਸਾਂ, ਵੱਖ-ਵੱਖ ਟਾਈਮਜ਼ੋਨ",
    ],
    learningModelHeading: "ਸਾਡਾ ਸਿੱਖਣ ਮਾਡਲ",
    learningModelSub: "ਅਕਾਲ ਕਿਡਜ਼ ਵਿੱਚ ਬੱਚੇ ਕਿਵੇਂ ਸਿੱਖਦੇ ਹਨ",
    learningCards: [
      {
        icon: "🧠",
        title: "ਗੁਰਬਾਣੀ ਕੰਠ",
        desc: "ਯਾਦ ਕਰਕੇ ਆਤਮਿਕ ਤਾਕਤ ਅਤੇ ਧਿਆਨ ਦਾ ਵਿਕਾਸ।",
      },
      {
        icon: "✍️",
        title: "ਸੁਨਹਿਰੀ ਪੰਨੇ",
        desc: "ਗੁਰਬਾਣੀ ਲਿਖ ਕੇ ਸਮਝ ਅਤੇ ਅਨੁਸ਼ਾਸਨ।",
      },
      {
        icon: "📚",
        title: "ਖੇਡ ਖੇਡ ਵਿੱਚ ਸਿੱਖਿਆ",
        desc: "ਸਾਖੀਆਂ ਅਤੇ ਚਰਚਾ ਰਾਹੀਂ ਜੀਵਨ ਸਿਧਾਂਤ ।",
      },
      {
        icon: "🌱",
        title: "ਜੀਵਨ ਨਾਲ ਜੋੜ",
        desc: "ਗੁਰਬਾਣੀ ਨੂੰ ਰੋਜ਼ਾਨਾ ਜੀਵਨ ਵਿੱਚ ਲਾਗੂ ਕਰਨਾ।",
      },
    ],
    coursesHeading: "ਕੋਰਸ ਅਤੇ ਬੈਚ",
    coursesText:
      "ਅਕਾਲ ਕਿਡਜ਼ ਵਿੱਚ ਦਾਖਲਾ ਉਮਰ ਨਹੀਂ, ਸਿੱਖਣ ਦੇ ਪੱਧਰ ਅਨੁਸਾਰ ਹੁੰਦਾ ਹੈ।",
    levels: ["ਮੂਲ ਪੱਧਰ", "ਸਮਝ", "ਗਹਿਰਾਈ", "ਨਿਪੁੰਨਤਾ"],
    classFormat: [
      "45 ਮਿੰਟ ਦੀਆਂ ਲਾਈਵ ਕਲਾਸਾਂ",
      "ਸ਼ਾਮ ਦਾ ਸਮਾਂ (ਲੋਕਲ ਟਾਈਮ ਅਨੁਸਾਰ)",
      "ਗਲੋਬਲ ਵਿਦਿਆਰਥੀ",
    ],
    batchesBtn: "ਬੈਚ ਅਤੇ ਪੱਧਰ ਵੇਖੋ",
    admissionHeading: "ਦਾਖਲੇ ਖੁੱਲ੍ਹੇ ਹਨ – ਸੀਟਾਂ ਸੀਮਿਤ",
    admissionText:
      "ਅਕਾਲ ਕਿਡਜ਼ ਵਿੱਚ ਦਾਖਲਾ ਲੈਣਾ ਬਹੁਤ ਆਸਾਨ ਹੈ। " +
      "ਤੁਸੀਂ ਆਨਲਾਈਨ ਦਾਖਲਾ ਲੈ ਸਕਦੇ ਹੋ ਜਾਂ ਵਟਸਐਪ ਰਾਹੀਂ ਸਿੱਧਾ ਸੰਪਰਕ ਕਰ ਸਕਦੇ ਹੋ।",
    admissionBtn: "ਦਾਖਲਾ ਲਵੋ",
    whatsappBtn: "ਵਟਸਐਪ ਕਰੋ",
  },
};

export default homeforTranslations;
